// extracted by mini-css-extract-plugin
export default {"Container":"chart_Container__eSRKc","chat-wrapper":"chart_chat-wrapper__Q8a0X","chart":"chart_chart__6s0ae","details":"chart_details__pf1oS"};